import { theme } from './theme'

export const LightTheme = { ...theme };